// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--FbZlF","tag":"_93444fe79c--tag--2Dt1u"};